import { mountL3App } from '@loop3/clerk'
import { TooltipProvider } from '@loop3/ui'
import { App } from './App'
import { ErrorFallback } from './lib/error-fallback'
import './globals.css'

// Allowed satellite domains that can redirect users here for sign-in.
// Without this, Clerk blocks the post-sign-in redirect back to the satellite.
// Configurable via env var so preview/prod URLs can be added without code changes.
const allowedRedirectOrigins = (
  import.meta.env.VITE_CLERK_ALLOWED_REDIRECT_ORIGINS ?? ''
)
  .split(',')
  .map((s: string) => s.trim())
  .filter(Boolean)

mountL3App({
  app: 'platform',
  App,
  appOwnsRouter: true,
  wrappers: [TooltipProvider],
  clerk: { allowedRedirectOrigins },
  errorFallback: ErrorFallback,
})
